import { ReactNode } from 'react'

import PanelRadioGroup from './PanelRadioGroup'
import styles from './PanelOptionList.module.scss'

type PanelOption = {
  id: string
  label: ReactNode
  hint?: ReactNode
  disabled?: boolean
}

type PanelOptionListProps = {
  options: PanelOption[]
  selectedId: string | null | undefined
  onSelect: (id: string) => void
  ariaLabel: string
}

/** A scrollable single-choice list, e.g. restaurants or times */
export default function PanelOptionList({
  options,
  selectedId,
  onSelect,
  ariaLabel,
}: PanelOptionListProps) {
  return (
    <PanelRadioGroup
      items={options}
      selectedId={selectedId}
      onSelect={onSelect}
      ariaLabel={ariaLabel}
      className={styles.list}
      itemClassName={styles.option}
      selectedClassName={styles.selected}
      renderItem={option => (
        <>
          <span className={styles.text}>
            <span>{option.label}</span>
            {option.hint && <span className={styles.hint}>{option.hint}</span>}
          </span>
          <span className={styles.radio} aria-hidden />
        </>
      )}
    />
  )
}
